import React from "react";
import { Link } from "react-router-dom";
import { usePlans } from "../hooks/usePlans";
import PlanCard from "../components/PlanCard";
import "../styles/saas.css";

export default function LandingPage() {
  const { plans, loading, error } = usePlans();

  return (
    <div className="saas-page saas-landing">
      <header className="saas-header">
        <Link to="/" className="saas-logo">Beentara</Link>
        <nav>
          <Link to="/pricing">Pricing</Link>
          <Link to="/compare">Compare</Link>
          <Link to="/login">Login</Link>
        </nav>
      </header>

      <section className="saas-hero">
        <h1>Run your business on Beentara</h1>
        <p>CRM, invoicing, e-commerce, and staff management — one platform.</p>
        <div className="saas-hero__actions">
          <Link to="/signup?plan=starter" className="saas-btn saas-btn--primary">Start Free Trial</Link>
          <Link to="/compare" className="saas-btn saas-btn--secondary">Compare plans</Link>
        </div>
      </section>

      <section className="saas-plans-grid">
        {loading && <p>Loading plans…</p>}
        {error && <p className="saas-error">{error}</p>}
        {!loading && plans.map((plan, i) => <PlanCard key={plan.id} plan={plan} highlighted={i === 1} />)}
      </section>

      <footer className="saas-footer">
        <Link to="/privacy">Privacy</Link>
        <Link to="/terms-conditions">Terms</Link>
      </footer>
    </div>
  );
}
